import { BusinessChartAlternative, Coins, DollarSimple } from '@vy/ui-design-system';
import { REPORT_TYPES, ReportType } from '../reports-page-types/report-type';

type ConfigOption = {
  title: string;
  description: string;
  type: ReportType;
};

export type SuggestedReportConfigItem = {
  title: string;
  icon: React.ReactNode;
  iconBackgroundColor: string;
  options: ConfigOption[];
};

export const SUGGESTED_REPORTS_CONFIG: SuggestedReportConfigItem[] = [
  {
    title: 'Billing',
    icon: <DollarSimple />,
    iconBackgroundColor: '#E7F2FF',
    options: [
      {
        title: 'Billing forecast',
        description: 'Upcoming invoices',
        type: REPORT_TYPES.UPCOMING_INVOICES,
      },
      { title: 'AR Health', description: 'Overdue cohort', type: REPORT_TYPES.AR_AGING },
      {
        title: 'Email exception',
        description: 'Track email delivery issues',
        type: REPORT_TYPES.FAILED_INVOICE_DELIVERIES,
      },
      {
        title: 'Customers & Contracts',
        description: 'All customers with their contracts',
        type: REPORT_TYPES.CUSTOMER_MASTER,
      },
    ],
  },
  {
    title: 'Usage & Data',
    icon: <BusinessChartAlternative />,
    iconBackgroundColor: '#EBE7FF',
    options: [
      {
        title: 'Commitment vs. usage',
        description: 'Compare usage vs. commitment',
        type: REPORT_TYPES.COMMITMENT_USAGE,
      },
      {
        title: 'Uncharged usage',
        description: 'Detect un billed events',
        type: REPORT_TYPES.UNCHARGED_USAGE,
      },
      {
        title: 'Anonymous customers',
        description: 'New customers imported',
        type: REPORT_TYPES.ANONYMOUS_CUSTOMERS,
      },
      { title: 'Usage by product', description: 'Product breakdown', type: REPORT_TYPES.PRODUCTS_USAGE },
      { title: 'Usage Report', description: 'Usage data with tier breakdown', type: REPORT_TYPES.USAGE_REPORT_V2 },
      { title: 'Commitment vs Usage - Detailed', description: 'Per-period commitment consumption with monthly breakdown', type: REPORT_TYPES.COMMITMENT_VS_USAGE },
      { title: 'Unmetered Events', description: 'Events without meters', type: REPORT_TYPES.UNMETERED_EVENTS }, 
    ],
  },
  {
    title: 'Accounting & SaaS KPIs',
    icon: <Coins />,
    iconBackgroundColor: '#DFFAE5',
    options: [
      {
        title: 'ARR / MRR',
        description: 'Recurring revenue waterfall',
        type: REPORT_TYPES.RECURRING_REVENUE,
      },
      {
        title: 'NRR / GRR',
        description: 'Net & gross revenue retention',
        type: REPORT_TYPES.NRR_GRR,
      },
      {
        title: 'Revenue Waterfall',
        description: 'Analyze recognized revenue',
        type: REPORT_TYPES.CUSTOMER_REVENUE,
      },
      {
        title: 'Journal Entries',
        description: 'Derived journal entries by period',
        type: REPORT_TYPES.JOURNAL_ENTRIES,
      },
    ],
  },
];
